import type { FaireProductEntity } from "../../entity_types/product";

export const p_6g95rbg37c: FaireProductEntity = {
  token: "p_6g95rbg37c",
  type: "product",
  name: "Magic Spell Candles - Soul Sticks Protection (20)",
  brandToken: "b_89kf2nlsjr",
  brandName: "Designs by Deekay Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/696a9983127a7017731b7ad7c7aa05f334fe314d61ab865ad4f38162c3f159a7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d84352d6eeb14bfa239e25732907d21f498471aece0cc129b272853a5c7d5cf5.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Magic Spell Candles - Soul Sticks Protection (20)\n \n PRODUCT SPECS\n • Pack Count: 20 candles per box\n • Size: 4 inches each\n • Burn Time: Approx. 2-2.5 hours each\n • Format: Unscented magic spell candles\n • Color: Black (color variation can occur as these are handmade)\n \n RETAIL PERFORMANCE\n • Protection products are core performers in metaphysical retail\n • Black candle format is a staple for ritual and altar assortments\n • Easy cross-merchandise with cleansing sprays, incense, and herbs\n • Box of 20 supports both value and routine ritual use\n • Strong anchor item for protection-themed displays\n\nNote: Color variation may occur.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:01.694Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
